export default __webpack_public_path__ + "static/media/vehelix_gb_flag.b8dae36e.svg";